import React from 'react';
import './Backdrop.css';
const Backdrop = props =>
  props.show ? (
    <div
      className={props.class ? 'Backdrop_mb_topfilter' : 'Backdrop '}
      onClick={props.clicked}
    ></div>
  ) : null;
export default Backdrop;
